//npm install ngeohash
import ngeohash from 'ngeohash';
import { GeoPoint } from "firebase/firestore";

/**
 * Formats location data to match your Flutter AdListing model precisely.
 * With geohash and geopoint structured exactly as your Firestore expects.
 */
export const generateGeoHashData = (lat, lng) => {
  const hash = ngeohash.encode(lat, lng, 9); // 9 characters for high precision
  return {
    geohash: hash,
    geopoint: new GeoPoint(lat, lng)
  };
};

export const formatLocationForFirestore = (place, lat, lng) => {
  // 1. Generate the hash (precisely 9 chars as per Flutter)
  const hash = ngeohash.encode(lat, lng, 9);
  
  return {
    city: place.city || '',
    state: place.state || '',
    street: place.street || '',
    village: place.village || place.neighbourhood || '',
    neighbourhood: place.neighbourhood || '',
    latitude: lat,
    longitude: lng,
    // This MUST match your Firestore structure exactly
    geoHashData: {
      geohash: hash,
      geopoint: generateGeoHashData(lat, lng).geopoint
    }
  };
};
